// Milliseconds before Ontame stops waiting for a consent signal and stays off.
const CONSENT_TIMEOUT_MS = 5000;

export const ontameScriptHTML = (
  tenant_id: string
) => `<script type="text/javascript">
    ; (function (p, l, o, w, i, n, g) { if (!p[i]) { p.GlobalSnowplowNamespace = p.GlobalSnowplowNamespace || []; p.GlobalSnowplowNamespace.push(i); p[i] = function () { (p[i].q = p[i].q || []).push(arguments) }; p[i].q = p[i].q || []; n = l.createElement(o); g = l.getElementsByTagName(o)[0]; n.async = 1; n.src = w; g.parentNode.insertBefore(n, g) } }(window, document, 'script', 'https://cdn.ontame.io/3.4.0/skYkappS.js', 'ontame'));
    const matchDomains = ['hr-manager.net', 'reachmee.com', '.webcruiter.'];
    const matchFunction = linkElement => matchDomains.some(domain => linkElement.href.includes(domain));

    let ontameConsentHandled = false;
    function initOntame(statistics) {
      if (ontameConsentHandled) return;
      ontameConsentHandled = true;
      if (statistics) {
        window.ontame('newTracker', 'clj', 'collector.ontame.io',
          {
            appId: "${tenant_id}",
            cookieName: 'ontame_',
            cookieSameSite: 'Lax',
            discoverRootDomain: true,
            cookieLifetime: 86400 * 365,
            crossDomainLinker: matchFunction
          }
        );
        window.ontame('trackPageView');
      }
    }

    window.addEventListener('CookiebotOnConsentReady', function (e) {
      initOntame(Cookiebot.consent.statistics);
    }, false);

    window.addEventListener('talentech:consentReady', function (e) {
      initOntame(!!(e.detail && e.detail.statistics));
    }, false);

    setTimeout(function () { initOntame(false); }, ${CONSENT_TIMEOUT_MS});

    </script>`;

export const ontameJobIdTrackEventHTML = () => `<script type="text/javascript">
    let jobTrackConsentHandled = false;
    function applyJobConsent(statistics) {
      if (jobTrackConsentHandled) return;
      jobTrackConsentHandled = true;
      if (statistics) {
        window.ontame('trackStructEvent', { category: 'job', action: 'jobView', label: "{ATS_ID}" });
      }
    }

    window.addEventListener('CookiebotOnConsentReady', function (e) {
      applyJobConsent(Cookiebot.consent.statistics);
    }, false);

    window.addEventListener('talentech:consentReady', function (e) {
      applyJobConsent(!!(e.detail && e.detail.statistics));
    }, false);

    setTimeout(function () { applyJobConsent(false); }, ${CONSENT_TIMEOUT_MS});
    </script>`;
